module.exports = __webpack_public_path__ + "static/media/oops.d8ef8158.png";